import React, { useState, useRef } from 'react'
import { Table, Button } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import Fetch from '@components/CRUD/Fetch'
// import ListOperation from '@components/CRUD/ListOperation'
import { client } from '@utils/client'

const List = () => {
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const { t } = useLocalization()

  const handleReload = () => {
    fetchRef.current.reload()
  }
  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const fetch = async () => {
    const result = await client
      .get('/users', {
        params: {
          skip: (page - 1) * pageSize,
          limit: pageSize,
        },
      })
      .then((res) => res.data)
    return result
  }

  const columns = [
    {
      title: t('user.listScreen.column.email'),
      dataIndex: 'email',
      key: 'email',
      width: '20%',
    },
    {
      title: t('user.listScreen.column.firstname'),
      dataIndex: 'profile',
      key: 'firstname',
      width: '20%',
      render: (row) => row.firstname,
    },
    {
      title: t('user.listScreen.column.lastname'),
      dataIndex: 'profile',
      key: 'lastname',
      width: '20%',
      render: (row) => row.lastname,
    },
    {
      title: t('user.listScreen.column.gender'),
      dataIndex: 'profile',
      key: 'gender',
      width: '20%',
      render: (row) => row.gender,
    },
    // {
    //   title: t('user.listScreen.column.action'),
    //   width: '15%',
    //   render: function Action(record) {
    //     return (
    //       <ListOperation
    //         row={record}
    //         basePath="/users"
    //         isEdit={false}
    //         isDelete={false}
    //       />
    //     )
    //   },
    // },
  ]

  return (
    <Fetch fetch={fetch} params={{ page, pageSize }} ref={fetchRef}>
      {({ data, total }) => (
        <PageLayout
          title={t('user.listScreen.title')}
          shownBack={false}
          extra={[
            <Button
              key="reload"
              icon={<ReloadOutlined />}
              onClick={handleReload}
            >
              {t('user.listScreen.reload')}
            </Button>,
          ]}
        >
          <Table
            rowKey="id"
            onChange={handleChange}
            columns={columns}
            dataSource={data}
            pagination={{
              defaultCurrent: defaultPageSize,
              defaultPageSize: defaultPageSize,
              current: page,
              pageSize,
              total,
            }}
          />
        </PageLayout>
      )}
    </Fetch>
  )
}

export default List
